import { Component, OnInit } from '@angular/core';
import { PermissionService } from '../../shared/services/permission.service'
import { Adal4Service, Adal4HTTPService } from 'adal-angular4';
import { UserService } from '../../shared/services/user.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: []
})
export class HomeComponent implements OnInit {
  canLogin: boolean = true; 
  homeClass="container-no-msg";
  showAccessAlertMsg: boolean = false;
  accessAlertMsg = "Você não possui autorização de acesso ao Sistema. Para concessão de acesso, favor solicitar via Vale Support Center (VSC).";
  enableCache = true;
  clicouLogin = false;

  constructor(private service: Adal4Service, 
    private http: Adal4HTTPService, 
    private permissionService: PermissionService    
    ) { }
    
  ngOnInit() {
        
    //this.service.handleWindowCallback();
    // Check if the user is authenticated. If not, call the login() method
    if (this.service.userInfo.authenticated) {

      localStorage.setItem("SessionExpired", "false");

      this.canLogin = false;
      
      var expirationDate = this.service.userInfo.profile.exp;
      //console.log("Exp:", expirationDate);
      var dataExp = new Date(expirationDate*1000);     
      //console.log("dataExp:", dataExp);      
      localStorage.setItem("tokenExpDate", dataExp.toString());
    
    }else if(this.service.userInfo.error){
      this.showAccessAlertMsg = true;
      this.homeClass ="container-msg";
      console.log("UserInfo:", this.service.userInfo.error);
     // setTimeout(function(){ this.http. }, 7000);
    }
  }
  // Logout Method
  public login() {
    localStorage.setItem("clicouLogin", "1")
    this.service.login();
  }

}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/home/home.component.ts